import React from 'react';
import PropTypes from 'prop-types';
import { List } from 'immutable';
import AlertDescription from '@Pages/Alerts/AlertsComponents/AlertDescription';

import './QueryRow.custom.scss';

function QueryRow({ description, structures, openStructureDialog }) {
  return (
    <div className="create-alert-dialog-row create-alert-dialog-row-query">
      <div className="create-alert-dialog-column-label">Query:</div>
      <div className="create-alert-dialog-column-content">
        {(description || structures) && (
          <AlertDescription
            description={description}
            structures={structures}
            openStructureDialog={openStructureDialog}
            showLabel="Show Query"
            hideLabel="Hide Query"
          />
        )}
      </div>
    </div>
  );
}

QueryRow.propTypes = {
  description: PropTypes.string,
  structures: PropTypes.instanceOf(List),
  openStructureDialog: PropTypes.func.isRequired,
};

export default QueryRow;
